// extracted by mini-css-extract-plugin
export var accountButton = "StartButton-module--accountButton--GG8+-";
export var startButton = "StartButton-module--startButton--ccagZ";